export const interstitialTypes = Object.freeze({
  page: '_page',
})

export default interstitialTypes
